
import user2 from "../assets/images/users/2.png";
import logo from "../assets/images/brand/logo.jpeg";
import favicon from "../assets/images/brand/logoicon.png";
import activeicon from "../assets/images/brand/active.png";
import inactiveicon from "../assets/images/brand/inactive.png";
import Vacanticon from "../assets/images/brand/vacant.png";
import barimage from "../assets/images/brand/bar001.png";
const AssetImages = {
    user2,
    logo,
    favicon,
    activeicon,
    inactiveicon,
    Vacanticon,
    barimage
  };
  export default AssetImages;